import { Box } from "@mui/material";
import { TABLES } from "../../../../Apis/Tables";
import { EmployeesIcon, IconBuildingTable, IconVehicle } from "../../../../components/buttons/IconButtons";
import { CustomStyleIconCircleContainer } from "../../../../components/Styles";
import CompanySection from "../../../Dashboard/Contractors/SubComponents/ContractorDetailsFlows/CompanySection";
import EmployeeSection from "../../../Dashboard/Contractors/SubComponents/EmployeeSection";
import VehicleSection from "../../../Dashboard/Contractors/SubComponents/VehicleSection";
import { PROFILE_MODEL } from "../../../DocumentationApprovalFlow/Model/Model";
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend
 * @Email: sgarcia@ibl.mx
 */
export const ORDER_SECTION = {
    COMPLETE_ORDER:  'COMPLETE_ORDER',
    DETAILS: 'DETAILS'
};

export const getSections = ({ userTypeId, userId, supplierId}) => [
    {
        id: 1,
        key: 'company',
        label: 'company_documentation',
        icon: <IconBuildingTable className='w-20px h-20px' />,
        content: () => <CompanySection
            userTypeId={userTypeId}
            userId={userId}
            profile={PROFILE_MODEL.COMPANY}
            historyModel={TABLES.HISTORY_SUPPLIER_IN_CHARGE_DOCUMENTATION_LEVEL}
            noInformationTitle={'no_company_documentation'}
        />,
    },
    {
        id: 2,
        key: 'employee',
        label: 'employee_documentation',
        icon: <EmployeesIcon className='w-20px h-20px' />,
        content: () => <EmployeeSection
            userTypeId={userTypeId}
            supplierId={supplierId}
            profile={PROFILE_MODEL.EMPLOYEE}
            model={TABLES.SUPPLIER_EMPLOYEE_DOCUMENTATION_LEVEL}
            historyModel={TABLES.HISTORY_SUPPLIER_EMPLOYEE_DOCUMENTATION_LEVEL}
            noInformationTitle={'no_employee_documentation'}
        />
    },
    {
        id: 3,
        key: 'vehicle',
        label: 'vehicle_documentation',
        icon: <IconVehicle className='w-20px h-20px' />,
        content: () => <VehicleSection
            userTypeId={userTypeId}
            supplierId={supplierId}
            profile={PROFILE_MODEL.VEHICLE}
            model={TABLES.SUPPLIER_VEHICLE_DOCUMENTATION_LEVEL}
            historyModel={TABLES.HISTORY_SUPPLIER_VEHICLE_DOCUMENTATION_LEVEL}
            noInformationTitle={'no_vehicle_documentation'}
        />
    },
    ];

   export const getColumns = (t, className = '') => [
    {
        field: 'label',
        label: 'description',
        width: 'w-100',
        render: (val, row) => (
            <div className={`d-flex align-items-center gap-2 ${className}`}>
                <Box sx={CustomStyleIconCircleContainer}>{row.icon}</Box>
                <p className='fs-14px font-color-text-950 ibl-font-w-600 m-0'>{t(val)}</p>
            </div>
        )
    }
   ];
//supppliers
export const STEPS_SUPPLIER_EMPLOYEE_FLOW_CREATE = {
    COMPANY_DETAILS: 0, 
    MANAGER_DETAILS: 1,
    OTHER_DETAILS: 2,
    ADD_PHOTO: 3,
    SUMMARY: 4,
};

export const STEPS_SUPPLIER_EMPLOYEE_FLOW_CREATE_WITHOUT_EXTRA_DATA = {
    COMPANY_DETAILS: 0,
    MANAGER_DETAILS: 1,
    ADD_PHOTO: 2,
    SUMMARY: 3,
};

export const STEPS_SUPPLIER_EMPLOYEE_FLOW_UPDATE = {
    COMPANY_DETAILS: 0,
    MANAGER_DETAILS: 1,
    OTHER_DETAILS: 2,
    ADD_PHOTO: 3,
};
export const STEPS_SUPPLIER_EMPLOYEE_FLOW_UPDATE_WITHOUT_EXTRA_DATA = {
    COMPANY_DETAILS: 0,
    MANAGER_DETAILS: 1,
    ADD_PHOTO: 2,
};
//employees for supplier 
   export const STEPS_EMPLOYEE_SUPPLIER_CREATE = {
    MANAGER_DETAILS: 0,
    OTHER_DETAILS: 1,
    ADD_PHOTO: 2,
    SUMMARY: 3,
};
export const STEPS_EMPLOYEE_SUPPLIER_CREATE_NO_DETAILS = {
    MANAGER_DETAILS: 0,
    ADD_PHOTO: 1,
    SUMMARY: 2,
};

export const STEPS_EMPLOYEE_SUPPLIER_UPDATE = {
   MANAGER_DETAILS: 0,
    OTHER_DETAILS: 1,
    ADD_PHOTO: 2,
}
export const STEPS_EMPLOYEE_SUPPLIER_UPDATE_NO_DETAILS = {
    MANAGER_DETAILS: 0,
    ADD_PHOTO: 1,
}